import { render, staticRenderFns } from "./eleDeviation.vue?vue&type=template&id=0cc96837&scoped=true"
import script from "./eleDeviation.vue?vue&type=script&lang=js"
export * from "./eleDeviation.vue?vue&type=script&lang=js"
import style0 from "./eleDeviation.vue?vue&type=style&index=0&id=0cc96837&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0cc96837",
  null
  
)

export default component.exports